function Title(props) {
  return (
    <div className="w-screen pt-4">
      <p className="text-4xl text-center font-display font-bold">{props.text}</p>
    </div>
  );
}

export default Title;
